import styled from 'styled-components'

import { BodyText } from '@/ui/atoms/body-text'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const FooterAppBannerContainer = styled.article(
  ({ theme }) => `
  & > img {
  align-self: end;
  };
  display: flex;
  padding: 1.2rem ${theme.spacing.husky} 0;
  justify-content: center;
  background-color: ${theme.colors.purple.light4};

  ${MEDIA_QUERIES(theme).small} {
    gap: ${theme.spacing.defaultSmall};
  }

  ${MEDIA_QUERIES(theme).medium} {
    gap: ${theme.spacing.xLarge};
  }

  ${MEDIA_QUERIES(theme).large} {
    display: flex;
    gap: ${theme.spacing.giant};
    padding: ${theme.spacing.large} ${theme.spacing.husky} 0;
    justify-content: center;
    background-color: ${theme.colors.purple.light4};
  }
  `
)

export const QRCodeContainer = styled.section<{ isFrench?: boolean }>(
  ({ theme, isFrench }) => `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${theme.spacing.default};
  background-color: ${theme.colors.purple.light4};
  justify-content: center;
  margin-bottom: 20px;

  & > a > button {
    white-space: ${isFrench ? 'inherit' : 'nowrap'};
  }

  ${MEDIA_QUERIES(theme).medium} {
    align-items: center;
    gap: ${theme.spacing.xLarge};
    white-space: inherit;
  }

  `
)

export const QRTitleContainer = styled.section(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.mini};
  `
)

export const QRCodeSection = styled.section(
  ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: ${theme.spacing.default};
  `
)

export const CanvasWrapper = styled.section<{ isMobile?: boolean }>(
  ({ theme, isMobile }) => `
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.grey.primary};
  padding-bottom: ${isMobile ? '0' : theme.spacing.large}; ;
  align-items: center;
  gap: 2.6rem;
  min-width: 17rem;
  flex: 1;
  color: ${theme.colors.purple.light4};
  border-radius: ${theme.borderRadius.xLarge};
  max-width: 23rem;
  min-width: 23rem;
  & > section:first-child {
    display: flex;
    gap: ${theme.spacing.defaultSmall};
    margin-top: ${theme.spacing.large};
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 ${theme.spacing.large};
  }
  `
)

export const CanvasTitle = styled.section`
  font-size: 1.6rem;
  white-space: nowrap;
`

export const CanvasBottomWrapper = styled.section(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  width:100%;
  border-top: 1px solid ${theme.colors.grey.light1};
  color: ${theme.colors.white};
  padding: 1.0rem 2.4rem 1.2rem;
  `
)

export const CanvasBottomBodyText = styled(BodyText)(
  ({ theme }) => `
  width: 100%;
  color: ${theme.colors.white};
  `
)
